/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import AppStore from './app';
import AuthStore from './auth';
import ContactStore from './contact';
import ConversationStore from './conversation';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'net-easymeeting-client-mobile-devices',
      paths: [
        'AuthStore.token',
        'AppStore.cameraName',
        'AppStore.isDesktopApp',
        'AppStore.freeclientRoom',
        'AppStore.freeclientName',
        'AppStore.selectedIODevices',
        'AuthStore.rememberedUsername',
        'AuthStore.rememberedPassword',
        'AuthStore.autoAnswerFav',
        'ConversationStore.notificationList'
      ],
      storage: localStorage
    })
  ],
  state: {
    standBy: false
  },
  getters: {
    standBy (state) {
      return state.standBy;
    }
  },
  mutations: {
    setStandBy (state, status) {
      state.standBy = status;
    }
  },
  actions: {
    setStandBy ({ commit }, status) {
      commit('setStandBy', status);
    }
  },
  modules: {
    AppStore,
    AuthStore,
    ContactStore,
    ConversationStore
  }
});
